export default __webpack_public_path__ + "static/media/PlasmidDesign.56e0e695.pdf";